// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HM3SB","footer":"styles_footer__hn9jZ"};